import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {DomSanitizer} from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { utils } from 'src/app/utils/utils';

@Component({
  selector: 'app-imagen',
  templateUrl: './imagen.component.html',
  styleUrls: ['./imagen.component.scss', '../../estilosModales.scss']
})
export class ImagenComponent implements OnInit {

  public _utils: utils;

  constructor(
    public dialogRef: MatDialogRef<ImagenComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this._utils = new utils();
    console.log(this.data);
  }

  cerrarModal() {
    this.dialogRef.close();
  }

  descargarFoto() {
    const url = `${this._utils.url}Fotografia/descargarFoto?nombreFoto=${this.data.nombreFoto}&extension=${this.data.extensionFoto}&idRazonSocial=${this.data.idRazonSocial}`;
    this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
      FileSaver.saveAs(blob, `${this.data.nombreFoto}.${this.data.extensionFoto}`);
    });
  }

}
